<template>
    <div>
        <sections :titles="sectionNames" @changeSection="sectionChangeHandler">
            <edit-settings
                v-show="selectedSection==0"
                v-if="cardInfo"
                :cardInfo="cardInfo"
                @showMessage="showMessageHandler"
            />
            <reset-password
                v-show="selectedSection==1"
                v-if="cardInfo"
                :cardID="cardInfo.id"
                @showMessage="showMessageHandler"
            />
            <edit-balance
                v-show="selectedSection==2"
                v-if="cardInfo && isSupervisor"
                :cardID="cardInfo.id"
                @showMessage="showMessageHandler"
            />
            <account-card-report
                v-show="selectedSection==3 && isSupervisor || selectedSection==2 && !isSupervisor"
                :cardID="card.id"
                :currency="card.currencyCode"
            />
            <update-nickname 
                v-show="selectedSection==3"
                v-if="cardInfo && !isSupervisor"
                :cardID="card.id"
                :nickName="cardInfo.nickName"
                @showMessage="showMessageHandler"
                @update="$emit('update')"
            />
        </sections>
        <custom-snackbar
            :text="message.text"
            :purpose="message.purpose"
            v-if="message.visible"
            @close="message.visible = false"
        ></custom-snackbar>
    </div>
</template>

<script>
import axios from '@/Helpers/AxiosInstance.js'
import Sections from '@/components/ReusableComponents/Sections/Sections.vue'
import EditSettings from './EditSettings.vue'
import ResetPassword from './ResetPassword.vue'
import EditBalance from './EditBalance.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import AccountCardReport from './AccountCardReport.vue'
import UpdateNickname from './UpdateNickname.vue'
export default {
    components: {
        Sections,
        EditSettings,
        ResetPassword,
        EditBalance,
        CustomSnackbar,
        AccountCardReport,
        UpdateNickname,
    },
    props: {
        card: Object,
    },
    created() {
        this.getInfo()
    },
    data() {
        return {
            selectedSection: 0,
            cardInfo: null,
            message: {
                visible: false,
                purpose: 'success',
                text: 'Successfully Saved',
            },
        }
    },
    watch: {
        card() {
            this.getInfo()
        },
    },
    methods: {
        getInfo() {
            axios
                .get('WebShop/GetAccountCardInfo', {
                    params: { accountCardId: this.card.id },
                })
                .then(resp => (this.cardInfo = resp.data.response))
        },
        sectionChangeHandler(index) {
            this.message.visible = false
            this.selectedSection = index
        },
        showMessageHandler(settings) {
            this.message.purpose = settings.purpose
            this.message.text = settings.text
            this.message.visible = true
        },
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        sectionNames() {
            var list = [
                this.$t('ACCOUNT_CARDS__SETTINGS'),
                this.$t('ACCOUNT_CARDS__RESET_PASSWORD'),
                this.$t('ACCOUNT_CARDS__OPERATION_HISTORY'),
            ]
            if (this.isSupervisor) {
                list.splice(2, 0, 'Balance')
            }
            if(!this.isSupervisor) {
                list.push(this.$t('ACCOUNT_CARDS__UPDATE_NICKNAME'))
            }
            return list
        },
    },
}
</script>

<style scoped lang= "scss">
/deep/ .item {
    padding: 0;
}
</style>
